import axios from "axios";
import { DELETE_CONTACT, CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE } from "./type";
import { CONTACTS } from "endpointsConst";

const URL = CONTACTS;
export function deleteContact(id) {
    return async (dispatch) => {
        try {
            await axios.delete(URL + `/${id}`).then(() => {
                dispatch({ type: DELETE_CONTACT, payload: id });
                dispatch({
                    type: CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE,
                    payload: { contact_id: id },
                });
            });
        } catch (error) {
            // TODO handle error
        }
    };
}
